// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oDASB{display:flex;align-items:center;gap:8px}.bMFGx{width:8px;height:8px;border-radius:50%}.bMFGx.RTYja{box-sizing:border-box;background:none;border:1px dashed}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `oDASB`,
	"dot": `bMFGx`,
	"hollow": `RTYja`
};
export default ___CSS_LOADER_EXPORT___;
